import { mapGetters } from "vuex"
import { orderBy } from "lodash"

import profile_utilities from "../../../mixins/ProfileUtilities"
import project_utilities from "../../../mixins/ProjectUtilities"

const handles_team_members = {
    mixins: [profile_utilities, project_utilities],
    methods: {
        is_boss_id (user_id) {
            if(this.project) {
                if(this.project.pm_id) return this.project.pm_id === user_id
                if(!this.project.pm_id) return this.project.pic_id === user_id
            }
            return false
        },
        team_member_capacity (user) {
            if(!!user && !!this.project) {
                if(user.id === this.project.pic_id) return "PIC"
                if(user.id === this.project.pm_id) return "PM"
            }
            return "D"
        },
        team_capacity_by_index (index) {
            if(this.project.internal) {
                if(index === 0) return "PM"
            } else {
                if(!!this.project.pm_id && (index === 0)) return "PM"
                if((!!this.project.pm_id && (index === 1)) || (!this.project.pm_id && (index === 0))) return "PIC"
            }
            return "D"
        },
        task_users_by_task_id (task_id) {
            return this.raw_task_user_records.find(task_user => {
                return (task_user.project_id === this.project.id) && (task_user.task_id === task_id)
            })
        },
        task_user (task_id, user_id) {
            return this.raw_task_user_records.find(task_user => {
                return (task_user.project_id === this.project.id) && (task_user.task_id === task_id) && (task_user.user_id === user_id)
            })
        },
        task_user_value (task_id, user_id, field) {
            const task_user = this.task_user(task_id, user_id) || {}
            return task_user[field]
        },
        save_task_user_field (task_id, user_id, value, field) {
            const task_user = this.task_user(task_id, user_id)
            if(!task_user) {
                this.$store.dispatch("CREATE_RECORD", {
                    entity: "task_user",
                    data: {
                        task_id,
                        user_id,
                        [field]: value
                    }
                }).catch(this.receive_error)
            } else {
                this.$store.dispatch("RECORD_SAVE", {
                    entity: "task_user",
                    id: task_user.id,
                    data: { [field]: value }
                }).catch(this.receive_error)
            }
        },
        team_member_by_id (user_id) {
            return this.entity_record("user", user_id)
        },
        project_team_member_days_off_for_range (project_team_member, task_start, task_end) {
            return this.off_days(this.team_member_by_id(project_team_member.user_id), task_start, task_end)
        },
        visible_project_team_members (hide_unstarred_team_members) {
            const team_members = this.project_team_members
            if(hide_unstarred_team_members) {
                return team_members.filter(project_user => {
                    if(project_user.starred) return true
                    const user = this.entity_record("user", project_user.user_id)
                    if((user.id === this.project.pm_id) || (user.id === this.project.pic_id)) return true
                    return false
                })
            }
            return team_members
        },
        visible_team_members (hide_unstarred_team_members) {
            const team_members = this.team_members
            if(hide_unstarred_team_members) {
                return team_members.filter(user => {
                    if((user.id === this.project.pm_id) || (user.id === this.project.pic_id)) return true
                    const project_user = this.entity_records("project_user").find(project_user => (project_user.project_id === this.project.id) && (project_user.user_id === user.id))
                    return !!project_user && !!project_user.starred
                })
            }
            return team_members
        }
    },
    computed: {
        ...mapGetters(["entity_records", "entity_record"]),
        raw_task_user_records () {
            return this.entity_records("task_user")
        },
        im_pic_or_pm () {
            if(!this.profile_id || !this.project) return false
            return (this.project.pic_id === this.profile_id) || (this.project.pm_id === this.profile_id)
        },
        project_team_members () {
            if(!this.project || !this.project.id) return []
            return orderBy(this.project_users_for_project_id(this.project.id), project_user => {
                const user = this.entity_record("user", project_user.user_id)
                if(!user) return "9.ZZZ"
                if(user.id === this.project.pm_id) return `1.${user.initials}`
                if(user.id === this.project.pic_id) return `2.${user.initials}`
                if(project_user.starred) return `3.${user.initials}`
                return `4.${user.initials}`
            })
        },
        team_members () {
            if(!this.project || !this.project.id) return []
            return orderBy(this.users_for_project_id(this.project.id), user => {
                const project_user = this.entity_records("project_user").find(project_user => (project_user.project_id === this.project.id) && (project_user.user_id === user.id))
                if(user.id === this.project.pm_id) return `1.${user.initials}`
                if(user.id === this.project.pic_id) return `2.${user.initials}`
                if(!!project_user && project_user.starred) return `3.${user.initials}`
                return `4.${user.initials}`
            })
        },
        team_editable () {
            if(this.im_pic_or_pm) return this.editable
            return this.editable // already depends on team membership
        }
    }
}

export default handles_team_members
